import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import api from '@/api';
import { TitleWithQuestion } from '@/common/TitleWithQuestion';
import FollowUpEntriesTable from '@/tables/FollowUpEntriesTable';
import { GroupHeaderWrapper } from '~/styles/layoutElements';

export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/follow-ups/entries/',
)({
  component: FollowUpsScreen,
});

function FollowUpsScreen() {
  const { t } = useTranslation();
  const { groupName } = Route.useParams();
  const { data: groupData } = api.getGroupBySlug.useQuery({
    path: { group_slug: groupName },
  });

  return (
    <>
      <GroupHeaderWrapper>
        <TitleWithQuestion
          title={t('sidebar.follow-ups')}
          helpKey="follow-ups"
        />
      </GroupHeaderWrapper>
      <FollowUpEntriesTable
        groupId={groupData?.id ?? 0}
        groupName={groupData?.name ?? ''}
      />
    </>
  );
}
